import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box } from '@mui/material';
import { PosterVariant } from '../hooks/useFragmentPosterPolling';
import { FragmentCardPosterWithPolling } from './FragmentCardPosterWithPolling';
import { FragmentCardThumbnailsHover } from './FragmentCardThumbnailsHover';
import { useFragmentCardThumbnailsHover } from './useFragmentCardThumbnailsHover';

export type FragmentCardVideoPosterAreaProps = {
  fragment: FragmentListItemDto;
  posterSrc: string | null;
  variant: PosterVariant | null;
};

/**
 * Video card poster plus optional hover thumbnail carousel from fragment.thumbnails.
 */
export function FragmentCardVideoPosterArea({
  fragment,
  posterSrc,
  variant,
}: FragmentCardVideoPosterAreaProps) {
  const { showCarousel, frameIndex, handleMouseEnter, handleMouseLeave } =
    useFragmentCardThumbnailsHover(fragment.thumbnails);

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ position: 'relative', width: '100%', height: '100%' }}
    >
      <FragmentCardPosterWithPolling
        fragmentId={fragment.id}
        posterSrc={posterSrc}
        variant={variant}
      />
      {showCarousel && fragment.thumbnails ? (
        <FragmentCardThumbnailsHover thumbnails={fragment.thumbnails} frameIndex={frameIndex} />
      ) : null}
    </Box>
  );
}
